// extracted by mini-css-extract-plugin
module.exports =  {"root":"X6qERSX0Rgo2o1HpBY_O","title":"Z0uT0JZemrGdiD1TKfI3"};